import "./SwitchComp.css";
import { defineComponent as r, openBlock as l, createElementBlock as o, normalizeClass as t, renderSlot as a, createElementVNode as s, toDisplayString as d, createCommentVNode as n } from "vue";
import { _ as u } from "./_plugin-vue_export-helper.dad06003.js";
const p = r({
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Boolean,
      required: !0
    },
    label: {
      type: String,
      default: void 0
    },
    yesText: {
      type: String,
      default: void 0
    },
    noText: {
      type: String,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    containerClassObject() {
      return {
        switch: !0,
        "switch--disabled": this.disabled
      };
    },
    inputClassObject() {
      return {
        switch__input: !0,
        "switch__input--disabled": this.disabled
      };
    },
    sliderClassObject() {
      return {
        switch__slider: !0,
        "switch__slider--checked": this.modelValue
      };
    },
    yesOrNoText() {
      if (!(!this.yesText || !this.noText))
        return this.modelValue ? this.yesText : this.noText;
    }
  },
  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
});
const c = { class: "switch__label" }, h = ["id", "t-sel", "disabled"], _ = ["t-sel"];
function b(e, i, m, y, f, C) {
  return l(), o("label", {
    class: t(e.containerClassObject)
  }, [
    a(e.$slots, "label", {}, () => [
      s("span", c, d(e.label), 1)
    ], !0),
    s("input", {
      type: "checkbox",
      id: e.id,
      "t-sel": e.id,
      disabled: e.disabled,
      onInput: i[0] || (i[0] = (T) => e.toggle()),
      class: t(e.inputClassObject)
    }, null, 42, h),
    s("div", {
      class: t(e.sliderClassObject)
    }, null, 2),
    e.yesOrNoText ? (l(), o("span", {
      key: 0,
      "t-sel": `${e.id}-yesNoText`,
      class: "switch__yesNoText"
    }, d(e.yesOrNoText), 9, _)) : n("", !0)
  ], 2);
}
const O = /* @__PURE__ */ u(p, [["render", b], ["__scopeId", "data-v-05bc0ea1"]]);
export {
  O as SwitchComp
};
//# sourceMappingURL=SwitchComp.js.map
